/**
 * ハンバーガーメニュー
 * 1. クローズアニメーション：Bootstrap が即時 visibility:hidden にする前に inline style で上書き
 * 2. マウスホイールのスクロール伝播防止
 * 3. offcanvas 開閉中の ScrollTrigger 誤発火防止
 *    - 根本対処: jquery.common.js の ignoreMobileResize:true（URL バー起因の resize を無視）
 *    - 補助: Bootstrap の overflow:hidden によるレイアウト変化対策で開閉時に disable/enable
 */
let hamburger = () => {
  const panel = document.getElementById('g-nav-panel');
  if (!panel) return;

  const CLOSE_DURATION = 600; // _hamburger.scss の .hiding clip-path 0.5s + 余白

  panel.addEventListener('show.bs.offcanvas', () => {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll().forEach(st => st.disable(false));
    }
  });

  panel.addEventListener('hidden.bs.offcanvas', () => {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll().forEach(st => st.enable(false));
      requestAnimationFrame(() => window.ScrollTrigger.refresh());
    }
  });

  // クローズ時：visibility を inline で維持し、アニメーション完了後に解除
  panel.addEventListener('hide.bs.offcanvas', () => {
    panel.style.visibility = 'visible';
    setTimeout(() => {
      panel.style.visibility = '';
    }, CLOSE_DURATION);
  });

  // マウスホイールのスクロールを body に伝播させない
  panel.addEventListener('wheel', (e) => {
    const body = panel.querySelector('.g-hamburger__body');
    if (!body) return;

    const { scrollTop, scrollHeight, clientHeight } = body;
    const delta = e.deltaY;
    const atTop = delta < 0 && scrollTop === 0;
    const atBottom = delta > 0 && scrollTop + clientHeight >= scrollHeight;

    if (!atTop && !atBottom) {
      e.preventDefault();
      body.scrollTop += delta;
    }
  }, { passive: false });
};

let init = () => {
  hamburger();
};

export default { init, hamburger };
